interface DebounceCallback<T extends Array<any>> {
  (...args: T): unknown
  clear: () => void
}

export function debounce<T extends Array<any>>(
  this: void,
  func: (...args: T) => unknown,
  timeout = 300
): DebounceCallback<T> {
  let timerRef: number | undefined = undefined
  const fn = (...args: T) => {
    clearTimeout(timerRef)
    timerRef = setTimeout(() => {
      func.apply(this, args)
    }, timeout) as unknown as number
  }

  fn.clear = () => {
    clearTimeout(timerRef)
  }

  return fn as DebounceCallback<T>
}
